import { getAPIPath, requestGooseAPI } from '../shared/request'
import { APIOffersClientDtoResponse } from '../types/api'
import { CLIENT_OFFERS_PATH } from '../types/constants'

export const ClientOffersService = {
  searchOffers: (
    locationName: string,
    options: {
      type?: 'PRIMARY' | 'SERVICE' | 'PET' | 'VOUCHER_OFFER'
      includes?: string[]
    }
  ): Promise<APIOffersClientDtoResponse> => {
    const { type, includes = [] } = options
    return requestGooseAPI<APIOffersClientDtoResponse>({
      url: getAPIPath(CLIENT_OFFERS_PATH, { locationId: locationName }),
      method: 'GET',
      params: {
        includes,
        type,
      },
    })
  },
}
